import { render, staticRenderFns } from "./ValueObjectList.vue?vue&type=template&id=37d2136a&"
import script from "./ValueObjectList.vue?vue&type=script&lang=js&"
export * from "./ValueObjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports